import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatDateTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
}

export function formatCurrency(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}

export function getModuleColor(moduleType) {
  const colors = {
    notes: '#2563EB',
    travel: '#0D9488',
    home: '#10B981',
    car: '#E97316',
    finance: '#8B5CF6',
  };
  return colors[moduleType] || '#0F172A';
}

export function getModuleIcon(moduleType) {
  const icons = {
    notes: 'BookOpen',
    travel: 'Plane',
    home: 'Home',
    car: 'Car',
    finance: 'TrendingUp',
  };
  return icons[moduleType] || 'Box';
}

export function getModuleName(moduleType) {
  const names = {
    notes: 'Memora Notes',
    travel: 'Memora Travel Tag',
    home: 'Memora Home Hub',
    car: 'Memora Car Diary',
    finance: 'Memora Wealth Compass',
  };
  return names[moduleType] || 'Unknown Module';
}

export function getModulePath(moduleType, tokenId) {
  const paths = {
    notes: `/notes/${tokenId}`,
    travel: `/travel/${tokenId}`,
    home: `/home/${tokenId}`,
    car: `/car/${tokenId}`,
    finance: `/finance/${tokenId}`,
  };
  return paths[moduleType] || '/dashboard';
}

export async function getGeolocation() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }
    
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      () => {
        resolve(null);
      },
      { timeout: 5000 }
    );
  });
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = (error) => reject(error);
  });
}

export function isAuthenticated() {
  return !!localStorage.getItem('memora_token');
}

export function getStoredUser() {
  const user = localStorage.getItem('memora_user');
  return user ? JSON.parse(user) : null;
}

export function setAuthData(token, user) {
  localStorage.setItem('memora_token', token);
  localStorage.setItem('memora_user', JSON.stringify(user));
}

export function clearAuthData() {
  localStorage.removeItem('memora_token');
  localStorage.removeItem('memora_user');
}
